import { getMilkReportYears } from "../../utils/year-milk-production.js";
import InfoCsvExportButton from "../../components/InfoCsvExportButton.js";
import { yearlyMilkCsv, yearlyMilkPeriodsCsv } from "../../utils/info-report-csv.js";
import { memo, useState } from "react";
import Spinner from "../../components/Spinner";
import SelectOwnerForm from "../../components/forms/OwnerSelect.js";
import { useSnackbar } from "../../utils/index.js";
import { getYearMilking, getOrganization } from "../../api/index.js";
import YearlyMilkProductionPdf from "../../components/info-pdfs/AnimalsYearlyProduction.js";


const YearMilking = () => {
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [milkingData, setMilkingData] = useState([]);
    const [ownerOrganization, setOwnerOrganization] = useState(null);

    const { error } = useSnackbar();
    const hasExportData = milkingData?.some((animal) => getMilkReportYears().some((year) => animal.yearlyProduction?.[year]?.length)
        || animal.unassignedPeriods?.length);

    const fetchMilkData = async (selOwner, selCategory) => {
        setIsLoading(true);
        if (selCategory === "alive") {
            setSelectedCategory("Λίστα Ζωντανών Ζώων");
        }
        if (selCategory === "dead") {
            setSelectedCategory("Λίστα Νεκρών Ζώων");
        }
        if (selCategory === "zyg") {
            setSelectedCategory("Λίστα Ζυγουριών");
        }
        const { success: scs, data, message } = await getYearMilking(selOwner, selCategory);
        if (scs) {
            setMilkingData(data);
            setStep(2);
        } else {
            error(message);
        }
        const { organization } = await getOrganization();
        setOwnerOrganization(organization);
        setIsLoading(false);
    };

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <SelectOwnerForm
                    setSelectedOwner={setSelectedOwner}
                    title={"Ετήσια Γαλακτοπαραγωγή"}
                    setStep={setStep}
                    method={fetchMilkData}
                    screenCase={"YearMilking"}
                />
            )}
            {step === 2 && (
                <>
                    <InfoCsvExportButton filename={`etisia_galaktoparagogi_${selectedOwner?.code || "ektrofi"}`}
                        getRows={() => yearlyMilkCsv(selectedOwner, selectedCategory, milkingData)} disabled={!hasExportData} />
                    <InfoCsvExportButton filename={`etisia_galaktoparagogi_ana_toketo_${selectedOwner?.code || "ektrofi"}`}
                        getRows={() => yearlyMilkPeriodsCsv(selectedOwner, selectedCategory, milkingData)}
                        disabled={!hasExportData}>
                        Αναλυτικό CSV ανά τοκετό
                    </InfoCsvExportButton>
                    <YearlyMilkProductionPdf
                        selectedOwner={selectedOwner}
                        animalsCategory={selectedCategory}
                        organization={ownerOrganization}
                        milkData={milkingData}
                        setStep={setStep}
                    />
                </>
            )}
        </>
    )
}

export default memo(YearMilking)